import { useQuery, useMutation, useLazyQuery } from "@apollo/client/react";import { Box, CircularProgress, Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import '../CierreVentas.scss';
import { CustomSection } from '../../EnvioCreation/components/CustomSection';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { ConsultaSection } from './ConsultaSection';
import { HeaderContentChip } from './HeaderContentChip';

import { AGREGAR_CONEXIONES } from '../../../data/graphQL/mutations/CierreDeVentas/AgregarConexionesFueraDeCierre';
import { ARMAR_TABLA } from '../../../data/graphQL/mutations/CierreDeVentas/ArmarTabla';
import { FACTURAR_SAP } from '../../../data/graphQL/mutations/CierreDeVentas/FacturarSAP';
import { POBLAR_CONEXIONES_PENDIENTES_FACTURAR } from '../../../data/graphQL/mutations/CierreDeVentas/PoblarPendientesAFacturar';
import { PROCESAR_FACTURAS } from '../../../data/graphQL/mutations/CierreDeVentas/ProcesarFacturas';
import { REVERTIR_ACTUALIZAR } from '../../../data/graphQL/mutations/CierreDeVentas/RevertirActualizar';
import { REVERTIR_DIFERENCIA } from '../../../data/graphQL/mutations/CierreDeVentas/RevertirDiferencia';
import toast from 'react-hot-toast';
import moment from 'moment';
import { adaptUltimoPeriodoCerrado, GET_ULTIMO_PERIODO_CERRADO } from '../../../data/graphQL/queries/CierreDeVentas/GetUltimoPeriodoCerrado';
import { AGREGAR_CIERRE_BOTON } from '../../../data/graphQL/mutations/CierreDeVentas/AgregarCierreBoton';
import { GET_CIERRE_BOTON } from '../../../data/graphQL/queries/CierreDeVentas/GetCierreBoton';
import { GET_CONEXIONES_A_EXPORTAR } from '../../../data/graphQL/queries/CierreDeVentas/getConexionesToExport';
import { headersExcelConexiones } from './adaptersConsulta';
import { GET_EXISTE_PERIODO_ACTIVO } from '../../../data/graphQL/queries/CierreDeVentas/GetExistePeriodoActivo';
import { downloadExcel } from '../../../utils/downloadExcel';

export const CierreVentasContent = ({ setChildrenAction }) => {

  const SEQUENCE = {
    ACTUALIZAR: {
      buttons: [
      { id: 'facturarSap', label: '1. Facturar SAP', numero: 1 },
      { id: 'pendiente', label: '2. Pendiente', numero: 2 }]

    },
    DIFERENCIAS: {
      buttons: [
      { id: 'armarTabla', label: '3. Armar tabla', numero: 3 },
      { id: 'procesarVentas', label: '4. Procesar ventas', numero: 4 },
      { id: 'actualizarDiferencias', label: '5. Actualizar diferencias', numero: 5 }]

    }
  };

  const allButtons = [
  ...SEQUENCE.ACTUALIZAR.buttons,
  ...SEQUENCE.DIFERENCIAS.buttons];


  const [sequenceState, setSequenceState] = useState({
    currentButtonIndex: 0,
    canRevertActualizar: false,
    canRevertDiferencias: false
  });

  const { data: dataUltimoPeriodoCerrado, loading: loadingUltimoPeriodoCerrado } =
  useQuery(GET_ULTIMO_PERIODO_CERRADO, {
    fetchPolicy: 'no-cache'
  });

  const { data: existePeriodoActivo } = useQuery(GET_EXISTE_PERIODO_ACTIVO, {
    fetchPolicy: 'no-cache'
  });

  const {
    idPeriodo,
    month,
    year,
    dateFrom,
    dateTo
  } = useMemo(() => adaptUltimoPeriodoCerrado(dataUltimoPeriodoCerrado), [dataUltimoPeriodoCerrado]);

  const [verEstadoBoton, { loading: loadingEstadoBoton }] = useLazyQuery(GET_CIERRE_BOTON, {
    fetchPolicy: 'no-cache'
  });
  const [getConexionesToExport] = useLazyQuery(GET_CONEXIONES_A_EXPORTAR, {
    fetchPolicy: 'no-cache'
  });

  const [facturarSAP, { loading: facturarLoading }] = useMutation(FACTURAR_SAP);
  const [poblarConexionesPendientesAFacturar, { loading: poblarLoading }] = useMutation(POBLAR_CONEXIONES_PENDIENTES_FACTURAR);
  const [armarTablaProcesarFacturas, { loading: armarTablaLoading }] = useMutation(ARMAR_TABLA);
  const [procesarFacturas, { loading: procesarFacturasLoading }] = useMutation(PROCESAR_FACTURAS);
  const [agregarConexionesFueraDeCierre, { loading: agregarConexionesLoading }] = useMutation(AGREGAR_CONEXIONES);
  const [revertirActualizar, { loading: revertirActualizarLoading }] = useMutation(REVERTIR_ACTUALIZAR);
  const [revertirDiferencia, { loading: revertirDiferenciaLoading }] = useMutation(REVERTIR_DIFERENCIA);

  const [confirmarBoton] = useMutation(AGREGAR_CIERRE_BOTON);

  useEffect(() => {
    const initializeButtonStates = async () => {
      if (idPeriodo && !sequenceState.initialized) {
        const buttonStates = [];

        for (const button of allButtons) {
          const state = await getButtonState(button);
          buttonStates.push(state);
        }

        const nextActiveIndex = buttonStates.findIndex((clicked) => !clicked);
        const allCompleted = nextActiveIndex === -1;

        const actualizarLength = SEQUENCE.ACTUALIZAR.buttons.length;
        const canRevertActualizar = nextActiveIndex === actualizarLength;
        const canRevertDiferencias = allCompleted;

        setSequenceState({
          currentButtonIndex: nextActiveIndex === -1 ? allButtons.length : nextActiveIndex,
          canRevertActualizar,
          canRevertDiferencias,
          initialized: true
        });
      }
    };

    const getButtonState = async (button) => {
      const { data } = await verEstadoBoton({
        variables: {
          boton: button.numero,
          idPeriodo
        }
      });
      return !!data?.cierreBoton;
    };

    initializeButtonStates();
  }, [idPeriodo, verEstadoBoton]);

  const adaptMutationInput = (variables) => {
    return {
      mes: variables?.month,
      anio: variables?.year,
      fechaDesde: variables?.dateFrom,
      fechaHasta: variables?.dateTo
    };
  };

  const onClickButton = async (mutation, variables, messages) => {
    const adaptedVariables = adaptMutationInput(variables);
    return toast.promise(
      mutation({ variables: adaptedVariables }).
      then((response) => {
        const responseData = response.data?.[Object.keys(response.data)?.at()];
        if (!responseData.success) throw new Error(responseData.message);

        if (responseData.success) {

          confirmarBoton({
            variables: {
              boton: sequenceState.currentButtonIndex + 1,
              idPeriodo
            }
          });

          const newIndex = sequenceState.currentButtonIndex + 1;

          const actualizarButtonsCount = SEQUENCE.ACTUALIZAR.buttons.length;
          const isMovingToNextSection = newIndex === actualizarButtonsCount;
          const isLastButton = newIndex >= allButtons.length;

          setSequenceState((prev) => ({
            ...prev,
            currentButtonIndex: newIndex,
            canRevertActualizar: isMovingToNextSection,
            canRevertDiferencias: isLastButton
          }));
        }

        return responseData.success;
      }),
      messages
    );
  };

  const exportConexiones = async () => {
    await toast.promise(
      (async () => {
        const response = await getConexionesToExport();

        const responseData = response.data?.[Object.keys(response.data)?.at()];
        if (!responseData?.success) return Promise.reject(responseData?.error || 'Error inesperado del servidor');

        const resultData = responseData.valorEsperado;
        const dataExport = resultData.map(({ __typename, ...item }) => item);

        try {
          downloadExcel({
            fileName: `conexiones_pendientes_${moment().format('DD_MM_YYYY')}`,
            sheet: 'Datos',
            tablePayload: {
              header: headersExcelConexiones,
              body: dataExport
            }
          });
        } catch (error) {
          Promise.reject('No se pudo descargar el archivo Excel');
        }
      })(),
      {
        loading: 'Generando Excel...',
        success: 'Excel descargado con éxito',
        error: (err) => err?.toString() || 'Error al generar el Excel'
      }
    );
  };

  const onClickPendienteButton = async (mutation, variables, messages) => {
    const adaptedVariables = adaptMutationInput(variables);

    try {
      const response = await toast.promise(
        mutation({ variables: adaptedVariables }),
        {
          loading: messages.loading,
          success: messages.success,
          error: () => 'Error al ejecutar la operación'
        },
        {
          success: {
            duration: 1
          },
          error: {
            duration: 3000
          }
        }
      );

      const responseData = response.data?.[Object.keys(response.data)?.at()];
      if (!responseData?.success) throw new Error(responseData?.error || messages.error);

      toast.success(messages.success, { duration: 3000 });

      confirmarBoton({
        variables: {
          boton: sequenceState.currentButtonIndex + 1,
          idPeriodo
        }
      });

      const newIndex = sequenceState.currentButtonIndex + 1;
      const actualizarButtonsCount = SEQUENCE.ACTUALIZAR.buttons.length;
      const isMovingToNextSection = newIndex === actualizarButtonsCount;
      const isLastButton = newIndex >= allButtons.length;

      setSequenceState((prev) => ({
        ...prev,
        currentButtonIndex: newIndex,
        canRevertActualizar: isMovingToNextSection,
        canRevertDiferencias: isLastButton
      }));

      return true;
    } catch (err) {
      toast.error(
        (t) =>
        <Box>
                        <p style={{ marginBottom: 8 }}>
                            {err.message || messages.error}
                        </p>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', fontSize: 11 }}>
                            <CustomButton
              label='Cerrar'
              onClick={() => toast.dismiss(t.id)}
              variant='outlined'
              sx={{ marginRight: 1, fontSize: 11 }} />
            
                            <CustomButton
              label='Exportar Excel'
              onClick={() => {
                toast.dismiss(t.id);
                exportConexiones();
              }}
              sx={{ fontSize: 11 }} />
            
                        </Box>
                    </Box>,

        {
          duration: 99999999
        }
      );
    }
  };

  const handleFacturarSAP = () => onClickButton(
    facturarSAP,
    { month, year, dateFrom, dateTo },
    {
      loading: 'Bajando ventas de SAP...',
      success: 'Ventas de SAP bajadas correctamente',
      error: 'Error al bajar ventas de SAP'
    }
  );

  const handlePendiente = () => onClickPendienteButton(
    poblarConexionesPendientesAFacturar,
    { month, year, dateTo },
    {
      loading: 'Buscando conexiones pendientes...',
      success: 'Conexiones pendientes actualizadas',
      error: 'Error al buscar conexiones pendientes'
    }
  );

  const handleArmarTabla = () => onClickButton(
    armarTablaProcesarFacturas,
    { month, year },
    {
      loading: 'Armando tabla de datos...',
      success: 'Tabla armada correctamente',
      error: 'Error al armar tabla'
    }
  );

  const handleProcesarVentas = () => onClickButton(
    procesarFacturas,
    { month, year },
    {
      loading: 'Procesando ventas...',
      success: 'Ventas procesadas correctamente',
      error: 'Error al procesar ventas'
    }
  );

  const handleActualizarDiferencias = () => onClickButton(
    agregarConexionesFueraDeCierre,
    { month, year },
    {
      loading: 'Actualizando diferencias...',
      success: 'Diferencias actualizadas correctamente',
      error: 'Error al actualizar diferencias'
    }
  );

  const handleRevert = (section) => {

    const mutation = section === 'ACTUALIZAR' ? revertirActualizar : revertirDiferencia;

    const actualizarLength = SEQUENCE.ACTUALIZAR.buttons.length;
    const firstButtonIndex = section === 'ACTUALIZAR' ? 0 : actualizarLength;

    return toast.promise(
      mutation({ variables: { idPeriodo } }).
      then((response) => {
        const responseData = response.data?.[Object.keys(response.data).at()];

        if (!responseData.success) throw new Error(responseData.message);

        const canRevertActualizar = firstButtonIndex === actualizarLength;
        const isLastButton = firstButtonIndex >= allButtons.length;

        setSequenceState((prev) => ({
          ...prev,
          currentButtonIndex: firstButtonIndex,
          canRevertActualizar: canRevertActualizar,
          canRevertDiferencias: isLastButton
        }));

        return responseData?.success;
      }),
      {
        loading: `Revirtiendo sección ${section.toLowerCase()}...`,
        success: `Sección ${section.toLowerCase()} revertida correctamente`,
        error: `Error al revertir sección ${section.toLowerCase()}`
      }
    );
  };

  const buttonHandlers = {
    'facturarSap': handleFacturarSAP,
    'pendiente': handlePendiente,
    'armarTabla': handleArmarTabla,
    'procesarVentas': handleProcesarVentas,
    'actualizarDiferencias': handleActualizarDiferencias
  };

  const ultimoCierreLoading = useMemo(() => {
    return loadingUltimoPeriodoCerrado || loadingEstadoBoton;
  }, [loadingUltimoPeriodoCerrado, loadingEstadoBoton]);

  const loadingAll = useMemo(() => {
    return (
      facturarLoading ||
      poblarLoading ||
      armarTablaLoading ||
      procesarFacturasLoading ||
      agregarConexionesLoading ||
      revertirActualizarLoading ||
      revertirDiferenciaLoading ||
      ultimoCierreLoading);

  }, [
  facturarLoading,
  poblarLoading,
  armarTablaLoading,
  procesarFacturasLoading,
  agregarConexionesLoading,
  revertirActualizarLoading,
  revertirDiferenciaLoading,
  ultimoCierreLoading]
  );

  const isButtonEnabled = (buttonIndex) => {
    return buttonIndex === sequenceState.currentButtonIndex && idPeriodo && !existePeriodoActivo?.existePeriodoActivo && !loadingAll;
  };

  const processedInputs = useMemo(() => {
    return structuredClone(inputs).map((input) => {
      if (input.type === 'button') {
        const buttonName = input.name;
        const buttonIndex = allButtons.findIndex((btn) => btn.id === buttonName);

        if (buttonIndex !== -1) {
          input.onClick = buttonHandlers[buttonName];
          input.disabled = !isButtonEnabled(buttonIndex);
        }
      }
      return input;
    });
  }, [
  sequenceState.currentButtonIndex,
  idPeriodo,
  loadingAll,
  existePeriodoActivo]
  );

  useEffect(() => {
    setChildrenAction(
      <HeaderContentChip
        loading={loadingUltimoPeriodoCerrado}
        ultimoPeriodo={`${moment().month(month - 1).format('MMMM')} | ${year}`}
        fechaDesde={moment(dateFrom)?.format('DD/MM/YYYY')}
        fechaHasta={moment(dateTo)?.format('DD/MM/YYYY')} />

    );
  }, [setChildrenAction, loadingUltimoPeriodoCerrado, month, year, dateFrom, dateTo]);

  return (
    <div className='cierre-ventas-content'>
            <div className="cierre-ventas-section">
                {ultimoCierreLoading &&
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 250
        }}>
                        <CircularProgress />
                    </Box>
        }

                {!ultimoCierreLoading && <>
                    <CustomSection
            title="Actualizar"
            collapsable
            headerRightContent={
            <CustomButton
              label='Revertir'
              onClick={() => handleRevert('ACTUALIZAR')}
              disabled={!sequenceState.canRevertActualizar || existePeriodoActivo?.existePeriodoActivo || loadingAll} />

            }>
            
                        <Grid container spacing={2}>
                            {processedInputs.
              filter((input) => input.section === 'Actualizar').
              map((input, index) => {
                const { descriptionText, ...restInput } = input;
                return (
                  <Grid
                    size={12}
                    key={`actualizar-${index}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                                            <RenderInputByTypeMobile
                      input={restInput} />
                    
                                            <label>{descriptionText}</label>
                                        </Grid>);

              })}
                        </Grid>
                    </CustomSection>

                    <CustomSection
            title="Diferencias"
            collapsable
            headerRightContent={
            <CustomButton
              label='Revertir'
              onClick={() => handleRevert('DIFERENCIAS')}
              disabled={!sequenceState.canRevertDiferencias || existePeriodoActivo?.existePeriodoActivo || loadingAll} />

            }>
            
                        <Grid container spacing={2}>
                            {processedInputs.
              filter((input) => input.section === 'Diferencias').
              map((input, index) => {
                const { descriptionText, ...restInput } = input;
                return (
                  <Grid
                    size={12}
                    key={`diferencias-${index}`}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                                            <RenderInputByTypeMobile
                      input={restInput} />
                    
                                            <label>{descriptionText}</label>
                                        </Grid>);

              })}
                        </Grid>
                    </CustomSection>
                </>}
            </div>
            <ConsultaSection
        key={`consulta-section-${idPeriodo}`}
        initialIdPeriodo={idPeriodo}
        initialMonth={month}
        initialYear={year} />
      
        </div>);

};

const inputs = [
{
  displayName: '1. Facturar SAP',
  name: 'facturarSap',
  type: 'button',
  sx: { width: 'max-content' },
  variant: 'outlined',
  col: 3,
  section: 'Actualizar',
  descriptionText: 'Baja las ventas de SAP del periodo seleccionado.'
},
{
  displayName: '2. Pendiente',
  type: 'button',
  name: 'pendiente',
  sx: { width: 'max-content' },
  variant: 'outlined',
  col: 3,
  section: 'Actualizar',
  descriptionText: 'Busca las conexiones que hay en Nutrihome que estan Pendientes de Facturar en el periodo y las pone como pendientes.'
},
{
  displayName: '3. Armar tabla',
  type: 'button',
  name: 'armarTabla',
  sx: { width: 'max-content' },
  variant: 'outlined',
  col: 3,
  section: 'Diferencias',
  descriptionText: 'Copia los datos crudos de SAP y Nutrihome en una nueva tabla donde se aplicaran los filtros.'
},
{
  displayName: '4. Procesar ventas',
  type: 'button',
  name: 'procesarVentas',
  sx: { width: 'max-content' },
  variant: 'outlined',
  col: 3,
  section: 'Diferencias',
  descriptionText: 'Copia los datos crudos de SAP y Nutrihome en una nueva tabla donde se aplicaran los filtros.'
},
{
  displayName: '5. Actualizar diferencias',
  type: 'button',
  name: 'actualizarDiferencias',
  sx: { width: 'max-content' },
  variant: 'outlined',
  col: 3,
  section: 'Diferencias',
  descriptionText: 'Busca las conexiones que el mes pasado estaban pendientes y las que el periodo actual no estan, y aquellas conexiones que fueron agregadas en el mes en curso de periodos anteriores.'
}];